// 拿到封装好的网络请求工具包
import request from '../utils/request'
// 排行榜接口
export const getRank1 = () => request({
  url: '/api/users/rank1',
})

export const getRank2 = () => request({
  url: '/api/users/rank2',
})

export const getRank3 = () => request({
  url: '/api/users/rank3',
})

export const getRank4 = () => request({
  url: '/api/users/rank4',
})